import { IPredefinedTheme } from "../../Themes";
import img1 from "./screenshot.png";

export const Theme: IPredefinedTheme = {
  name: "Monokai'ish",
  description: "Monokai'ish",
  credit: "eltea",
  screenshot: img1,
  colors: {
    primarylight: "#FFF",
    primary: "#F8F8F2",
    primarydark: "#FAFAEB",
    successlight: "#ADE146",
    success: "#A6E22E",
    successdark: "#98E104",
    errorlight: "#FF69A0",
    error: "#F92672",
    errordark: "#D10F56",
    secondarylight: "#AAA",
    secondary: "#888",
    secondarydark: "#666",
    warninglight: "#E1D992",
    warning: "#E6DB74",
    warningdark: "#EDDD54",
    infolight: "#92E1F1",
    info: "#66D9EF",
    infodark: "#31CDED",
    welllight: "#444",
    well: "#222",
    white: "#fff",
    black: "#000",
    hp: "#F92672",
    money: "#E6DB74",
    hack: "#A6E22E",
    combat: "#75715E",
    cha: "#AE81FF",
    int: "#66D9EF",
    rep: "#E69F66",
    disabled: "#66cfbc",
    backgroundprimary: "#272822",
    backgroundsecondary: "#1B1C18",
    button: "#333",
    maplocation: "#ffffff",
    bnlvl0: "#ffff00",
    bnlvl1: "#ff0000",
    bnlvl2: "#48d1cc",
    bnlvl3: "#0000ff",
  },
};
